// src/lib/motion.js
//
// Shared Framer Motion variants for a consistent, subtle animation language
// across the site. Import these into any page/component instead of
// redefining transitions inline everywhere.
//
// Usage:
//   import { motion } from 'framer-motion';
//   import { fadeUp, staggerContainer, cardItem } from '../lib/motion';
//
//   <motion.section variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }}>

export const EASE = [0.22, 1, 0.36, 1]; // smooth "ease-out-expo"-ish curve, no bounce

// Single element fade + slide up — use for section headers, hero content, cards
export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: EASE },
  },
};

// Slightly smaller movement, for inline/small elements (badges, buttons)
export const fadeUpSmall = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: EASE },
  },
};

// Plain fade, no movement — for background/overlay elements
export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.6, ease: EASE } },
};

// Parent wrapper for staggered children (e.g. a grid of cards)
export const staggerContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

// Child item to use inside a staggerContainer
export const cardItem = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: EASE },
  },
};

// Standard viewport settings — animate once, slightly before fully in view
export const defaultViewport = { once: true, amount: 0.2 };

// Shared hover/tap micro-interaction for buttons and clickable cards
export const tapScale = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 },
  transition: { duration: 0.15, ease: EASE },
};